var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.file)?_c('json-viewer',{attrs:{"value":_vm.file,"expand-depth":5,"expanded":true,"copyable":"","boxed":"","sort":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }